/*
  pdp-lightbox.js — Rita #62 (Figma "All photos", node 733:7065)
  ──────────────────────────────────────────────────────────────
  Desktop lightbox for the product gallery. Clicking the main image
  (or the "+N" veil on thumb 12, per Amine 2026-08-25) opens a modal:
  header bar (title · counter · close), contain-fit stage with round
  prev/next, 132px thumbnail rail on the right, 100px thumbs, active
  thumb ringed 2px #282d34. Scrim is black @ 72% (sampled off the
  frame render). Mobile keeps the theme's own zoom.

  Styles are injected from here so JS and CSS can never be
  cache-skewed against each other (the #68 lesson).
*/
(function () {
  if (window.__ggmPdpLightbox) return;
  window.__ggmPdpLightbox = true;

  var mqDesktop = window.matchMedia('(min-width: 1025px)');

  var style = document.createElement('style');
  style.textContent = [
    '.pdp-lightbox { position: fixed; inset: 0; z-index: 2147482000; display: flex; align-items: center; justify-content: center; }',
    '.pdp-lightbox__scrim { position: absolute; inset: 0; background: rgba(0, 0, 0, 0.72); }',
    '.pdp-lightbox__panel { position: relative; display: flex; flex-direction: column; width: min(1104px, calc(100vw - 64px)); height: min(700px, calc(100vh - 64px)); background: #ffffff; border-radius: 8px; overflow: hidden; }',
    '.pdp-lightbox__bar { display: flex; align-items: center; gap: 12px; padding: 14px 20px 14px 24px; border-bottom: 1px solid #f2f5f6; }',
    '.pdp-lightbox__title { flex: 1 1 0; min-width: 1px; margin: 0; font-family: var(--type_heading_font); font-size: 16px; line-height: 20px; font-weight: 700; color: #282d34; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }',
    '.pdp-lightbox__counter { font-size: 14px; line-height: 16px; color: #4d5257; white-space: nowrap; }',
    '.pdp-lightbox__close { display: flex; align-items: center; justify-content: center; width: 20px; height: 20px; padding: 0; border: none; background: transparent; cursor: pointer; color: #282d34; }',
    '.pdp-lightbox__close svg { width: 20px; height: 20px; display: block; }',
    '.pdp-lightbox__body { display: flex; flex: 1 1 0; min-height: 1px; width: 100%; }',
    '.pdp-lightbox__stage { position: relative; flex: 1 1 0; min-width: 1px; height: 100%; background: #ffffff; }',
    '.pdp-lightbox__img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; }',
    '.pdp-lightbox__nav { position: absolute; top: 50%; transform: translateY(-50%); width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: #ffffff; border: 1px solid #f2f5f6; border-radius: 999px; cursor: pointer; color: #282d34; padding: 0; }',
    '.pdp-lightbox__nav svg { width: 18px; height: 18px; display: block; }',
    '.pdp-lightbox__nav--prev { left: 16px; }',
    '.pdp-lightbox__nav--next { right: 16px; }',
    '.pdp-lightbox__thumbs { display: flex; flex-direction: column; gap: 10px; align-items: center; width: 132px; height: 100%; padding: 16px; border-left: 1px solid #f2f5f6; overflow-y: auto; overflow-x: hidden; box-sizing: border-box; flex-shrink: 0; }',
    '.pdp-lightbox__thumb { flex-shrink: 0; width: 100px; height: 100px; padding: 0; background: #ffffff; border: 1px solid #f2f5f6; border-radius: 2px; cursor: pointer; box-sizing: border-box; }',
    '.pdp-lightbox__thumb img { width: 100%; height: 100%; object-fit: contain; border-radius: 2px; display: block; }',
    '.pdp-lightbox__thumb.is-active { border: 2px solid #282d34; }',
    'body.pdp-lightbox-open { overflow: hidden; }',
    '@media (max-width: 1024px) { .pdp-lightbox { display: none; } }'
  ].join('\n');
  document.head.appendChild(style);

  var SVG_LEFT = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_RIGHT = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_CLOSE = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var root = null;
  var items = [];
  var current = 0;
  var lastFocus = null;
  var els = {};

  function collect() {
    items = [];
    var slides = document.querySelectorAll('#productSwiperElement [data-action="open-product-zoom"]');
    Array.prototype.forEach.call(slides, function (el) {
      var img = el.querySelector('img');
      if (!img) return;
      items.push({
        full: img.getAttribute('data-original-src') || img.getAttribute('data-src') || img.currentSrc || img.src,
        thumb: img.currentSrc || img.src || img.getAttribute('data-original-src'),
        alt: img.getAttribute('alt') || ''
      });
    });
  }

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'pdp-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Produktbilleder');
    root.innerHTML =
      '<div class="pdp-lightbox__scrim"></div>' +
      '<div class="pdp-lightbox__panel">' +
      '  <div class="pdp-lightbox__bar">' +
      '    <p class="pdp-lightbox__title"></p>' +
      '    <span class="pdp-lightbox__counter"></span>' +
      '    <button type="button" class="pdp-lightbox__close" aria-label="Luk">' + SVG_CLOSE + '</button>' +
      '  </div>' +
      '  <div class="pdp-lightbox__body">' +
      '    <div class="pdp-lightbox__stage">' +
      '      <img class="pdp-lightbox__img" alt="">' +
      '      <button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--prev" aria-label="Forrige billede">' + SVG_LEFT + '</button>' +
      '      <button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--next" aria-label="Næste billede">' + SVG_RIGHT + '</button>' +
      '    </div>' +
      '    <div class="pdp-lightbox__thumbs"></div>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(root);

    els.title = root.querySelector('.pdp-lightbox__title');
    els.counter = root.querySelector('.pdp-lightbox__counter');
    els.img = root.querySelector('.pdp-lightbox__img');
    els.thumbs = root.querySelector('.pdp-lightbox__thumbs');
    els.close = root.querySelector('.pdp-lightbox__close');

    root.querySelector('.pdp-lightbox__scrim').addEventListener('click', close);
    els.close.addEventListener('click', close);
    root.querySelector('.pdp-lightbox__nav--prev').addEventListener('click', function () { show(current - 1); });
    root.querySelector('.pdp-lightbox__nav--next').addEventListener('click', function () { show(current + 1); });
    document.addEventListener('keydown', function (e) {
      if (!root || root.style.display === 'none') return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { show(current - 1); }
      else if (e.key === 'ArrowRight') { show(current + 1); }
    });
  }

  function renderThumbs() {
    els.thumbs.innerHTML = '';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-lightbox__thumb';
      b.setAttribute('aria-label', 'Billede ' + (i + 1));
      var img = document.createElement('img');
      img.src = item.thumb;
      img.alt = item.alt;
      b.appendChild(img);
      b.addEventListener('click', function () { show(i); });
      els.thumbs.appendChild(b);
    });
  }

  function show(i) {
    if (!items.length) return;
    current = (i + items.length) % items.length;
    var item = items[current];
    els.img.src = item.full;
    els.img.alt = item.alt;
    els.counter.textContent = (current + 1) + ' / ' + items.length;
    var kids = els.thumbs.children;
    for (var k = 0; k < kids.length; k++) kids[k].classList.toggle('is-active', k === current);
    if (kids[current] && kids[current].scrollIntoView) {
      kids[current].scrollIntoView({ block: 'nearest' });
    }
    // warm the neighbours
    [current + 1, current - 1].forEach(function (n) {
      var it = items[(n + items.length) % items.length];
      if (it) { var pre = new Image(); pre.src = it.full; }
    });
  }

  function open(index) {
    collect();
    if (!items.length) return;
    build();
    var h1 = document.querySelector('h1');
    els.title.textContent = h1 ? h1.textContent.trim() : '';
    renderThumbs();
    root.style.display = 'flex';
    document.body.classList.add('pdp-lightbox-open');
    lastFocus = document.activeElement;
    show(index || 0);
    els.close.focus();
  }

  function close() {
    if (!root) return;
    root.style.display = 'none';
    document.body.classList.remove('pdp-lightbox-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Document-capture so we run before the theme's zoom (Delegate binds
  // click in the bubble phase) and before the thumb-select on the veil.
  document.addEventListener('click', function (e) {
    if (!mqDesktop.matches) return;
    if (!e.target || !e.target.closest) return;
    var zoomEl = e.target.closest('#productSwiperElement [data-action="open-product-zoom"]');
    var veilEl = e.target.closest('.pdp-thumb-more');
    if (!zoomEl && !veilEl) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    var idx = 0;
    if (zoomEl) {
      idx = parseInt(zoomEl.getAttribute('data-image-position'), 10);
      if (isNaN(idx)) idx = 0;
    } else {
      idx = 11; // the +N veil sits on tile 12
    }
    open(idx);
  }, true);
})();
